export const MACHINE_STATE = {
  DISABLED: 0,
  PREPARING: 1,
  IDLE: 2,
  USING: 3,
  Locked: 4,
};
